import { createFileRoute, redirect } from '@tanstack/react-router';
import { hasLivePortalSession } from '@/stores/portalAuth.store';

/**
 * Booking now lives in the {@link PortalBookVisitDialog} modal, triggered from
 * the Service history header and the membership hero — there's no standalone
 * booking page. This route only survives so old links/bookmarks land on the
 * visits list instead of a 404.
 */
export const Route = createFileRoute('/(portal)/portal/visits/book')({
  beforeLoad: () => {
    throw redirect({ to: hasLivePortalSession() ? '/portal/visits' : '/portal/login' });
  },
});
